import React, { useState, useRef, useEffect } from 'react';
import './JivanYatraSection.css';

const timelineData = [
  {
    year: '2000-2003',
    image: '/images/scsb-1.jpeg',
    title: 'स्वदेशीमें संपूर्ण परिवर्तन',
    description: (
      <>
        <p>‘राजीवभाई एक बुद्धिवादी प्रखर देशभक्त व्यक्ति थे जो भारत के लिए लगातार 20/22 साल तक काम करते रहे।’ पूरे भारत में दिन-रात प्रवास करते हुए राष्ट्रबंधु श्री. राजीवभाई दीक्षितजी ने 10,000 से ज्यादा अलग अलग विषयों पर व्याख्यान दिए। इन ज्वलंत व्याख्यानों से लाखों लोगों को देश के लिए काम करने की प्रेरणा मिली।</p>
        <p>इसी दौरान श्री. संजय ह. परदेशीजी ने राजीवभाई के साथ ‘HOW TO REVIVE INDIA..?’ ‘भारत कैसे बदले..?’ इस पर काम करना शुरू किया। राजीवभाई मानते थे कि स्वदेशी और मूलभूत बदल योजना विभाग (मूबयो) की सहायता से भारत में बदलाव हो सकता है। भारत के सामने कई समस्याएँ हैं, जिनमें से छह प्रमुख समस्याओं पर काम करते हुए संपूर्ण परिवर्तन का लक्ष्य रखा गया:</p>
        <ol className="jy-list">
          <li><strong>➤ आर्थिक पुनरुत्थान</strong></li>
          <li><strong>➤ खेती व्यवस्था</strong></li>
          <li><strong>➤ शिक्षा व्यवस्था</strong></li>
          <li><strong>➤ स्वास्थ्य व्यवस्था</strong></li>
          <li><strong>➤ न्याय व्यवस्था</strong></li>
          <li><strong>➤ शासन और प्रशासन व्यवस्था</strong></li>
        </ol>
      </>
    )
  },
  {
    year: '2004-2010',
    image: '/images/scsb-1.jpeg',
    title: 'स्वयं की फॅक्टरी और स्वदेशी साथ साथ',
    description: (
      <>
        <p>वर्ष 2005 में पुणे में श्री. संजय ह. परदेशीजी ने खुद की फॅक्टरी शुरू की, जहाँ सन 2017 तक 100 से ज्यादा लोग काम करते थे और ‘इंडस्ट्रियल क्रेन्स’ का निर्माण होता था। साथ में सिविल कन्स्ट्रक्शन का काम भी शुरू था।</p>
        <p>स्वदेशी और हिंदुत्व इन दो धर्मकार्य के लिए वे 2018 में अपनी फैक्ट्री से मुक्त हुए और अब बिजनेस सीमित करके अधिक समय धर्मकार्य को दे रहे हैं।</p>
      </>
    )
  },
  {
    year: '2011-2014',
    image: '/images/scsb-1.jpeg',
    title: 'विदेशमें सड़क और यातायात व्यवस्थाओंपर सादरीकरण',
    description: (
      <>
        <p>राजीवभाई दीक्षितजी के 2010 में गुजरने के बाद जीवन में खालीपन था। 2011 में ‘सुदर्शन न्यूज’ चैनल के संस्थापक श्री. सुरेश चव्हाणकेजी घर आए और 2011 से आज 2025 तक साथ हैं।</p>
        <p>इसी दौरान ‘HOW TO REVIVE INDIA..?’ पर सोचते हुए नए छह मुद्दे जोड़कर बारह सूत्री योजना बनाई और मूलभूत बदल योजना (मूबयो) के साथ स्वतंत्र ‘रचनात्मक विकास योजना (रवियो)’ विभाग स्थापित करने का प्रस्ताव रखा:</p>
        <ol className="jy-list">
          <li><strong>➤ पानी की योजना</strong></li>
          <li><strong>➤ बिजली निर्माण, संचय और वितरण की व्यवस्था</strong></li>
          <li><strong>➤ मलनिस्सारण और कूड़ा-करकट व्यवस्थापन</strong></li>
          <li><strong>➤ आम आदमी निवास योजना</strong></li>
          <li><strong>➤ संपूर्ण भारत की नई सड़क योजना</strong></li>
          <li><strong>➤ संपूर्ण भारत की नई यातायात योजना</strong></li>
        </ol>
        <p>तीन वर्षों की अथक मेहनत से ‘संपूर्ण भारत की नई सड़क और यातायात योजना’ लिखी गई — यह एक्शन प्लॅन भारत की यातायात व्यवस्था को 70% सुचारु कर सकता है और 70% दुर्घटनाएँ कम कर सकता है। इसका सादरीकरण सऊदी अरब की राजधानी रियाध में IRF (International Road Federation) की वार्षिक सभा सहित अनेक मान्यवर नेताओं और अधिकारियों के समक्ष हुआ। 190 पन्नों वाली यह योजना मानचित्रों सहित कार्यान्वयन के लिए तैयार है।</p>
      </>
    )
  },
  {
    year: '2015-2019',
    image: '/images/scsb-1.jpeg',
    title: 'भारत बचाओ यात्रा!',
    description: (
      <>
        <p>18 फरवरी 2018 से 22 अप्रैल 2018 — 65 दिनों में श्री. सुरेश चव्हाणकेजी के नेतृत्व में ‘भारत बचाओ यात्रा’ निकाली गई। श्री. संजय ह. परदेशीजी की मुख्य भूमिका रही और वे यात्रा के संगठन में बुनियादी तौर पर थे।</p>
        <p>कश्मीर से कन्याकुमारी और फिर दिल्ली तक लगभग 18,000 किमी प्रवास के साथ अनेक गाड़ियों के काफिले ‘हम दो, हमारे दो तो सबके दो’ के घोषवाक्य सहित आगे बढ़े। ‘जनसंख्या नियंत्रण कानून लाओ, देश बचाओ’ उद्देश्य के साथ यह यात्रा दिल्ली में संपन्न हुई।</p>
      </>
    )
  },
  {
    year: '2020-2023',
    image: '/images/scsb-1.jpeg',
    title: 'सीधी सोच, सीधी बात!',
    description: (
      <>
        <p>कोरोना काल में ‘सीधी सोच, सीधी बात’ नामक मंच की स्थापना की। इसके अंतर्गत कई महत्वपूर्ण व्यवस्थाओं के प्राथमिक प्रारूप लिखे गए:</p>
        <ul className="jy-list">
          <li><strong>➤ भारत की संपूर्ण नई न्याय व्यवस्था (प्राथमिक प्रारूप)</strong></li>
          <li><strong>➤ भारत की संपूर्ण नई शिक्षा व्यवस्था (प्राथमिक प्रारूप)</strong></li>
          <li><strong>➤ सामाजिक विचारधारा बदलने के उपाय</strong></li>
        </ul>
        <p>150 पन्नों की पुस्तक, जिसमें सभी प्रारूप एक साथ हैं, कई मान्यवर नेताओं और अधिकारियों को भेजी गई। 2020 में ही सुझाव दिया गया कि प्री-प्रायमरी से पीएचडी तक प्रत्येक अभ्यासक्रम मातृभाषा में पढ़ाया जाए और संपूर्ण भारत में चतुःस्तरीय भाषिक शिक्षाप्रणाली लागू हो:</p>
        <ul className="jy-list">
          <li><strong>➤ प्रथम भाषा — मातृभाषा</strong> (अपने-अपने राज्य की भाषा)</li>
          <li><strong>➤ दूसरी भाषा — राष्ट्रभाषा</strong> (हिंदी, संपर्क भाषा)</li>
          <li><strong>➤ तीसरी भाषा — अंतरराष्ट्रीय भाषा</strong> (अंग्रेजी)</li>
          <li><strong>➤ चौथी भाषा — मूलभूत भाषा</strong> (संस्कृत)</li>
        </ul>
        <p>इसी पुस्तक में अंत में देशभक्ति पर काव्यात्मक लेख भी शामिल हैं — ‘देश के लिए मरना मत’, ‘सोते रहो..! सोते रहो..!’, ‘अब नहीं! बस!’, ‘अब समय आ गया है..!’, ‘एक देश, भाषाएँ अनेक..!’ इत्यादि।</p>
      </>
    )
  },
  {
    year: '2024-2025',
    image: '/images/scsb-1.jpeg',
    title: 'एक देश, एक चुनाव (प्राथमिक प्रारूप)',
    description: (
      <>
        <p>‘एक देश, एक चुनाव’ का प्राथमिक प्रारूप लिखा गया और उसी पुस्तक में समाविष्ट किया गया। श्री. सुरेश चव्हाणकेजी के साथ कई मान्यवरों से भेंट और विस्तृत चर्चाएँ हुईं, जिनमें प्रमुख हैं:</p>
        <ul className="jy-list">
          <li><strong>१)</strong> मा. सड़क मंत्री <strong>श्री. नितिन गडकरीजी</strong></li>
          <li><strong>२)</strong> मा. मंत्री <strong>श्री. गिरीराज सिंहजी</strong></li>
          <li><strong>३)</strong> मा. राज्यसभा सांसद <strong>श्री. सुधांशु त्रिवेदीजी</strong></li>
          <li><strong>४)</strong> मा. सरसंघचालक <strong>श्री. मोहन भागवतजी</strong></li>
          <li><strong>५)</strong> मा. मंत्री <strong>श्री. एकनाथ शिंदेजी</strong></li>
          <li><strong>६)</strong> मा. मंत्री <strong>श्री. मंगलप्रसाद लोढ़ाजी</strong></li>
          <li><strong>७)</strong> मा. मंत्री <strong>श्री. राज्यवर्धन राठौड़जी</strong></li>
          <li><strong>८)</strong> मा. राज्यपाल <strong>हरिभाऊ बागडेजी</strong></li>
          <li><strong>९)</strong> मा. योगगुरुजी <strong>श्री. नागेन्द्रजी</strong></li>
          <li><strong>१०)</strong> <strong>मा. आचार्य बालकृष्णजी</strong> (पतंजलि योगपीठ)</li>
          <li><strong>११)</strong> सुप्रीम कोर्ट के अधिवक्ता <strong>श्री. विष्णु शंकर जैनजी</strong></li>
          <li><strong>१२)</strong> सुप्रीम कोर्ट के अधिवक्ता <strong>श्री. अश्विनी उपाध्यायजी</strong></li>
        </ul>
        <p>अंत में, सभी भारतवासियों से आवाहन है कि अपना जीवनकार्य करते हुए कुछ समय सनातन हिंदू धर्म और राष्ट्र के लिए अवश्य निकालें — <strong>देश है तो धर्म है, और धर्म है तो हम सुरक्षित हैं। जयहिन्द, जय श्रीराम!</strong></p>
      </>
    )
  }
];

const PrevIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11" stroke="#ff6b35" strokeWidth="2" fill="#fff" />
    <path d="M15 18L9 12L15 6" stroke="#ff6b35" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const NextIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11" stroke="#ff6b35" strokeWidth="2" fill="#fff" />
    <path d="M9 18L15 12L9 6" stroke="#ff6b35" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const JivanYatraSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const yearsBarRef = useRef(null);
  const yearRefs = useRef([]);

  // Scroll selected year into view on mobile
  useEffect(() => {
    if (yearRefs.current[currentIndex] && window.innerWidth <= 900) {
      yearRefs.current[currentIndex].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [currentIndex]);

  const goTo = (idx) => setCurrentIndex(idx);
  const prev = () => setCurrentIndex((prev) => (prev === 0 ? timelineData.length - 1 : prev - 1));
  const next = () => setCurrentIndex((prev) => (prev === timelineData.length - 1 ? 0 : prev + 1));

  return (
    <section className="jivanyatra-section">
      <div className="container">
        <div className="jy-header">
          <span className="jy-tab">जीवन यात्रा</span>
        </div>
        <div className="jy-timeline-bar">
          <button className="jy-nav-btn" onClick={prev} aria-label="पिछला वर्ष">
            <PrevIcon />
          </button>
          <div className="jy-years" ref={yearsBarRef}>
            {timelineData.map((item, idx) => (
              <div
                key={item.year}
                className={`jy-year${idx === currentIndex ? ' active' : ''}`}
                onClick={() => goTo(idx)}
                ref={el => yearRefs.current[idx] = el}
              >
                <span>{item.year}</span>
                <div className="jy-dot" />
              </div>
            ))}
          </div>
          <button className="jy-nav-btn" onClick={next} aria-label="अगला वर्ष">
            <NextIcon />
          </button>
        </div>
        <div className="jy-content-area">
          <div className="jy-img-box">
            <img src={timelineData[currentIndex].image} alt={timelineData[currentIndex].title} />
          </div>
          <div className="jy-details-box">
            <div className="jy-year-badge">{timelineData[currentIndex].year}</div>
            <div className="jy-title">{timelineData[currentIndex].title}</div>
            <div className="jy-desc">{timelineData[currentIndex].description}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JivanYatraSection;